import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import ActionButtons from '../../../ui/views/shippingSend/ActionButtons'
import ShippingSendForm from '../../../ui/views/shippingSend/FormWrapper'
import Step5SummaryUI from '../../../ui/views/shippingSend/Step5Summary'
import { STEPS } from '../../../common/constants'
import {
  shippingSend1FromPropTypes,
  shippingSend2ToPropTypes,
  shippingSend3ShipmentPropTypes,
  shippingSend4ServicesPropTypes,
} from '../../../common/propTypes'
import {
  formErrorsPropType,
  makeFieldErrorsPropType,
  makeValuesPropType,
} from '../../../common/formikPropTypes'
import { nullablePropType } from '../../../common/propTypes'

import { computeShippingWeight } from '../Step3Shipment'

const Step5Summary = ({
  newShipmentCode,
  shipmentWasCreated,
  values,
  fieldErrors,
  formErrors,
  onCancel,
  onSubmit,
  isSubmitting,
  cutoffErrors,
  onClickStep,
}) => {
  const [newShipmentCreated, setNewShipmentCreated] = useState(false)

  const summaryFieldErrors =
    cutoffErrors !== null
      ? {
          ...fieldErrors,
          from: {
            ...fieldErrors.from,
            pickUpTimeSlot: cutoffErrors,
          },
        }
      : fieldErrors

  useEffect(() => {
    if (newShipmentCode !== null) {
      setNewShipmentCreated(true)
    }
  }, [newShipmentCode])

  const shippingWeightDeclared = values.shipment.packages.reduce(
    (shippingWeightDeclared, pack) => {
      const packageWeight = computeShippingWeight(pack.weight, {
        weight: pack.weight,
        height: pack.height,
        width: pack.width,
        length: pack.length,
      })

      return shippingWeightDeclared + packageWeight
    },
    0,
  )

  return (
    <ShippingSendForm onSubmit={onSubmit}>
      <Step5SummaryUI
        shipmentWasCreated={shipmentWasCreated}
        shippingWeightDeclared={shippingWeightDeclared}
        values={values}
        fieldErrors={summaryFieldErrors}
        formErrors={formErrors}
        onClickStep={onClickStep}
        aditionalServices={
          values.services.withRefund ||
          values.services.insuranceMerchandise ||
          values.services.withReturn ||
          values.services.scanClientSlip
        }
      />

      {!newShipmentCreated ? (
        <ActionButtons
          onCancel={onCancel}
          onSubmit={onSubmit}
          currentStep={STEPS.SUMMARY}
          isSubmitting={isSubmitting}
        />
      ) : null}
    </ShippingSendForm>
  )
}

Step5Summary.propTypes = {
  newShipmentCode: PropTypes.string,
  shipmentWasCreated: PropTypes.bool,
  values: PropTypes.shape({
    from: makeValuesPropType(shippingSend1FromPropTypes).isRequired,
    to: makeValuesPropType(shippingSend2ToPropTypes).isRequired,
    shipment: makeValuesPropType(shippingSend3ShipmentPropTypes).isRequired,
    services: makeValuesPropType(shippingSend4ServicesPropTypes).isRequired,
  }).isRequired,

  fieldErrors: PropTypes.shape({
    from: nullablePropType(
      makeFieldErrorsPropType(shippingSend1FromPropTypes).isRequired,
    ),
    to: nullablePropType(
      makeFieldErrorsPropType(shippingSend2ToPropTypes).isRequired,
    ),
    shipment: nullablePropType(
      makeFieldErrorsPropType(shippingSend3ShipmentPropTypes).isRequired,
    ),
    services: nullablePropType(
      makeFieldErrorsPropType(shippingSend4ServicesPropTypes).isRequired,
    ),
  }).isRequired,

  formErrors: nullablePropType(formErrorsPropType.isRequired),

  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onClickStep: PropTypes.func.isRequired,
  cutoffErrors: PropTypes.object,
  isSubmitting: PropTypes.bool.isRequired,
}

export default Step5Summary
